import type { WallDefinition } from "./wallDefinitions";
import { STOCK_WALL_BALANCE_PROFILE } from "./wallBalanceProfiles";

export const STOCK_WALL_DEFINITION: WallDefinition = {
  id: "stock-wall",
  firstClearReward: STOCK_WALL_BALANCE_PROFILE.firstClearReward,
};

export const STOCK_WALL_BASE_NHOV_EXECUTION_LIMIT =
  STOCK_WALL_BALANCE_PROFILE.challenge.baseNhovExecutionLimit;
export const STOCK_WALL_REWARD_TARGET_CLEAR_MS =
  STOCK_WALL_BALANCE_PROFILE.reward.targetClearMs;
export const STOCK_WALL_REWARD_NHOV_LIMIT_BONUS_MIN =
  STOCK_WALL_BALANCE_PROFILE.reward.minimumNhovLimitBonus;
export const STOCK_WALL_REWARD_NHOV_LIMIT_BONUS_MAX =
  STOCK_WALL_BALANCE_PROFILE.reward.caps.base;

export function resolveStockWallRewardEffectiveMaxNhovLimitBonus(): number {
  return STOCK_WALL_REWARD_NHOV_LIMIT_BONUS_MAX;
}

export function resolveStockWallRewardNhovLimitBonus(
  bestClearMs: number | null,
  effectiveMaxNhovLimitBonus: number = resolveStockWallRewardEffectiveMaxNhovLimitBonus(),
): number {
  if (bestClearMs === null) return 0;
  if (!Number.isFinite(bestClearMs) || bestClearMs <= 0) {
    return effectiveMaxNhovLimitBonus;
  }

  const ratio = STOCK_WALL_REWARD_TARGET_CLEAR_MS / bestClearMs;

  return Math.min(
    effectiveMaxNhovLimitBonus,
    Math.max(STOCK_WALL_REWARD_NHOV_LIMIT_BONUS_MIN, Math.round(ratio)),
  );
}

export function resolveStockWallEffectiveNhovExecutionLimit(
  bestClearMs: number | null,
): number {
  return (
    STOCK_WALL_BASE_NHOV_EXECUTION_LIMIT +
    resolveStockWallRewardNhovLimitBonus(bestClearMs)
  );
}
